module.exports = __webpack_public_path__ + "static/media/logo_sd_group_inv.88cb1e3f.png";